import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  size?: AvatarSize;
  src?: string;
  alt?: string;
  children?: ReactNode;
}

const sizeClassName: Record<AvatarSize, string | undefined> = {
  sm: 'avatar--sm',
  md: undefined,
  lg: 'avatar--lg',
  xl: 'avatar--xl',
};

export function Avatar({ size = 'md', src, alt = '', className, children, ...props }: AvatarProps) {
  return (
    <span className={cn('avatar', sizeClassName[size], className)} {...props}>
      {src ? <img src={src} alt={alt} /> : children}
    </span>
  );
}

export interface AvatarGroupProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function AvatarGroup({ className, children, ...props }: AvatarGroupProps) {
  return (
    <div className={cn('avatar-group', className)} {...props}>
      {children}
    </div>
  );
}

export type KbdProps = HTMLAttributes<HTMLElement>;

export function Kbd({ className, ...props }: KbdProps) {
  return <kbd className={cn('kbd', className)} {...props} />;
}
